import { toast } from 'react-toastify';
import DivContainerBody from '../../../../../components/DivContainerBody';
import HeadTittle from '../../../../../components/HeadTittle';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import { ButtonNextStep } from '../../../../../components/buttons/ButtonNavigation';
import CreateMenuApp from '../Functionality/CreateMenuApp';
import { ButtonPrevStep } from './../../../../../components/buttons/ButtonNavigation';
import Availability from './Availability';
import CustomRestrictions from './CustomRestrictions';
import SetUp from './SetUp';
import Summary from './Summary';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CreateMenu = () => {
    const {
        t,
        item,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        handleCreate,
        handleStepChange,
        handleStepSetUp,
        emptyFields,
        handleChange,
        errorCode,
        allCourseType,
        setItem,
        allMeals,
        selectedMealTime,
        setSelectedMealTime,
        selectedDepartment,
        setSelectedDepartment,
        selectedUsers,
        setSelectedUsers,
        mealTime,
        allItem,
        allCafeterias,
        goBack,
        costInfo,
        isServingDateValid,
        departments,
        users,
        notAdded,
        notSelected,
        setDepartment,
        setMealTime,
        isValidCost,
        validateCost,
        showCostInfo
    } = CreateMenuApp();


    return (
        <>
            <HeadTittle onBack={goBack} name={'create'}/>
            <DivContainerBody>
                <>
                    <StepperTabs
                        id={null}
                        disabled={false}
                        steps={steps}
                        activeStep={activeStep}
                        isStepOptional={(step) => step === 2}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                    >
                        <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                            <div className='row'>
                                <SetUp
                                    allCafeterias={allCafeterias}
                                    allItem={allItem}
                                    allMeals={allMeals}
                                    costInfo={costInfo}
                                    disabled={disabled}
                                    emptyFields={emptyFields[0]}
                                    errorCode={errorCode}
                                    handleChange={handleChange}
                                    item={item}
                                    mealTime={mealTime}
                                    selectedMealTime={selectedMealTime}
                                    setItem={setItem}
                                    setSelectedMealTime={setSelectedMealTime}
                                    t={t}
                                    isValidCost={isValidCost}
                                    validateCost={validateCost}
                                    setMealTime={setMealTime}
                                    notSelected={notSelected}
                                    showCostInfo={showCostInfo}
                                />
                            </div>
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_cm_next_dish'
                                    text='next'
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        } else {
                                            toast.warn(t('please_fill_all_fields'));
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={1} activeStep={activeStep} normalHeight={true}>
                            <Availability
                                t={t}
                                item={item}
                                disabled={disabled}
                                emptyFields={emptyFields[1]}
                                handleChange={handleChange}
                                allCourseType={allCourseType}
                                departments={departments}
                                selectedDepartment={selectedDepartment}
                                setSelectedDepartment={setSelectedDepartment}
                                isServingDateValid={isServingDateValid}
                                setDepartment={setDepartment}
                                notSelected={notSelected}
                            />

                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_cm_back_file'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cm_next_file'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        }else if (notAdded){
                                             toast.warn(t('click_to_add'));
                                        } else {
                                            toast.warn(t('please_fill_all_fields'));
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={2} activeStep={activeStep} normalHeight={true}>
                            <div className='row'>
                                <CustomRestrictions
                                    disabled={disabled}
                                    users={users}
                                    selectedUsers={selectedUsers}
                                    setSelectedUsers={setSelectedUsers}
                                />
                            </div>
                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_cm_back_file'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cm_next_file'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        } else {
                                            toast.warn(t('please_fill_all_fields'));
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={3} activeStep={activeStep} normalHeight={true}>
                            <Summary
                                t={t}
                                item={item}
                                selectedMealTime={selectedMealTime}
                                selectedDepartment={selectedDepartment}
                                selectedUsers={selectedUsers}
                                allItem={allItem}
                                allCafeterias={allCafeterias}
                                showCostInfo={showCostInfo}
                            />
                            <div className='d-flex justify-content-between px-0 mb-2'>
                                <ButtonPrevStep
                                    id='btn_cm_next_dish'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cm_enroll'
                                    text='create'
                                    click={() => {
                                        handleCreate();
                                    }}
                                />
                            </div>
                        </StepTab>
                    </StepperTabs>
                </>
            </DivContainerBody>
        </>
    );
};

export default CreateMenu;
